<template>
  <div id="PageContainer" style="background-color: #e0fffd; min-height:160vh">
    <div style="height: 30px"></div>
    <div style="margin-left:20px; margin-right:20px; margin-top: 20px; display: flex; flex-direction: column">
      <h1>Your Messages</h1>
      <chat-window :currentUserId="currentUserId" :rooms="rooms" :messages="messages" />
    </div>
    <div style="margin-left:20px; margin-right:20px; margin-top: 20px; display: flex; flex-direction: column;">
      <h1>Today's Stats</h1>
      <div style="display: flex; flex-direction: row;"> 
        <div class="stats-grid-container">
          <div class="stats-stats" style="background-color:white">
            <div class="st-grid-container" style="justify-items: left;">

              <div class="st-grid1" style="width: 8vw">

                <p style="margin-bottom: 0px; font-size: 15px">New Favourites:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid yellow; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">38</h1>
                </div>

              </div>
              <div class="st-grid2" style="width: 8vw">
                <p style="margin-bottom: 0px; font-size: 15px">Total Favourites:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid DodgerBlue; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">266</h1>
                </div>
              </div>
              <div class="st-grid3" style="width: 8vw">
                <p style="margin-bottom: 0px; font-size: 15px">Scans:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid purple; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">84</h1>
                </div>
              </div>
              <div class="st-grid4" style="width: 8vw">
                <p style="margin-bottom: 0px; font-size: 15px">Total Scans:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid DodgerBlue; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">363</h1>
                </div>
              </div>
              <div class="st-grid5" style="width: 8vw">
                <p style="margin-bottom: 0px; font-size: 15px">Messages Today:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid red; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">23</h1>
                </div>
              </div>
              <div class="st-grid6" style="width: 8vw">

              </div>
              <div class="st-grid7" style="width: 8vw">
                <p style="margin-bottom: 0px; font-size: 15px">New Page Views:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid PaleGreen; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">118</h1>
                </div>
              </div>
              <div class="st-grid8" style="width: 8vw;">
                <p style="margin-bottom: 0px; font-size: 15px">Total Views:</p>
                <div style="display: flex; flex-direction: row;">
                  <div style="border-left: 2px solid DodgerBlue; height: 30px; margin-top: 5px"></div>
                  <h1 style="margin-left: 15px; color: black">1344</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="stats-status" style="background-color:white; display: flex; flex-direction:column; text-align:center">
            <base-dropdown>
              <base-button slot="title" type="secondary" class="dropdown-toggle" style="width: 80%; border-radius: 40px; border: 1px solid grey; margin-top: 8%">
                <span style="height: 15px;
                  width: 15px;
                  background-color: Lightgreen;
                  border-radius: 50%;
                  display: inline-block;"></span> Open
              </base-button>
              <a class="dropdown-item" href="#">
                <span style="height: 15px;
                  width: 15px;
                  background-color: LightSalmon;
                  border-radius: 50%;
                  display: inline-block;"></span>
                  Closed
                </a>
            </base-dropdown>
            <p>We are open until 10:00 p.m. today</p>
          </div>
          <div class="stats-notification" style="background-color:white; display: flex; flex-direction: column">
            <div style="margin: 3%">
              <div style="display: flex; flex-direction: row">
                <h2>Send a Notification</h2>
                 <base-button type="secondary" size="sm" style="border-radius: 50%; height: 30px; margin-left: 30px"><i class="fa fa-plus"></i></base-button>
              </div>
              <div style="display: flex; flex-direction: row">
                <p style>Subject: </p>
                <input type="text" id="fname" name="fname" style="width: 80%; height: 30px; margin-left: 5px;"><br><br>
              </div>
              Description:
              <input type="text" id="fname" name="fname" style="width: 95%; height: 120px; margin-left: 5px"><br><br>
              Users who have favourited you will be able to receive push notifications.
            </div>
            
          </div>
          <div class="stats-updates" style="background-color:white">
            <h2 style="margin-left: 3%; margin-top: 3%">Updates </h2>
            <div style="margin-left: 3%; display: flex; flex-direction: column; overflow-y: scroll; height: 80%" >
              
              <!-- Section to generate -->
              <div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div style="height: 1px; width: 90%; background-color:#f2f2f2; margin-bottom: 10px"></div>
                  <div style="display:flex; flex-direction:row">
                    <img src="../assets/avatar.jpg" style="height:100px; width: 100px;">
                    <span style="color: black; margin-left: 10px; margin-right: 2px"> This is filler text. This is filler text. This is filler text. This is filler text. </span>
                  </div>
                  <sp style="font-size:12px; margin-top: 3px">POSTED 5 HOURS AGO</sp>
                </div>
              </div>

              <div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div style="height: 1px; width: 90%; background-color:#f2f2f2; margin-bottom: 10px"></div>
                  <div style="display:flex; flex-direction:row">
                    <img src="../assets/avatar.jpg" style="height:100px; width: 100px;">
                    <span style="color: black; margin-left: 10px; margin-right: 2px"> This is filler text. This is filler text. This is filler text. This is filler text. </span>
                  </div>
                  <sp style="font-size:12px; margin-top: 3px">POSTED 5 HOURS AGO</sp>
                </div>
              </div>

              <div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div style="height: 1px; width: 90%; background-color:#f2f2f2; margin-bottom: 10px"></div>
                  <div style="display:flex; flex-direction:row">
                    <img src="../assets/avatar.jpg" style="height:100px; width: 100px;">
                    <span style="color: black; margin-left: 10px; margin-right: 2px"> This is filler text. This is filler text. This is filler text. This is filler text. </span>
                  </div>
                  <sp style="font-size:12px; margin-top: 3px">POSTED 5 HOURS AGO</sp>
                </div>
              </div>

              <div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div style="height: 1px; width: 90%; background-color:#f2f2f2; margin-bottom: 10px"></div>
                  <div style="display:flex; flex-direction:row">
                    <img src="../assets/avatar.jpg" style="height:100px; width: 100px;">
                    <span style="color: black; margin-left: 10px; margin-right: 2px"> This is filler text. This is filler text. This is filler text. This is filler text. </span>
                  </div>
                  <sp style="font-size:12px; margin-top: 3px">POSTED 5 HOURS AGO</sp>
                </div>
              </div>

              <div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div style="height: 1px; width: 90%; background-color:#f2f2f2; margin-bottom: 10px"></div>
                  <div style="display:flex; flex-direction:row">
                    <img src="../assets/avatar.jpg" style="height:100px; width: 100px;">
                    <span style="color: black; margin-left: 10px; margin-right: 2px"> This is filler text. This is filler text. This is filler text. This is filler text. </span>
                  </div>
                  <sp style="font-size:12px; margin-top: 3px">POSTED 5 HOURS AGO</sp>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div id='mydiv2'></div>
  </div>
</template>

<script>
  import ChatWindow from 'vue-advanced-chat'
  import 'vue-advanced-chat/dist/vue-advanced-chat.css'
  import postscribe from 'postscribe';
  export default {
    components: {
      ChatWindow
    },
    data() {
      return {
        rooms: [
          {
            roomId: 1,
            roomName: 'Person 1',
            lastMessage: {
              content: 'Last message received',
              sender_id: 1234,
              username: 'John Doe',
              timestamp: '10:20',
              date: 123242424,
              seen: false,
              new: true
            },
            users: [
              {
                _id: 1234,
                username: 'John Doe',
                status: {
                  state: 'online',
                  last_changed: 'today, 14:30'
                }
              },
              {
                _id: 4321,
                username: 'John Snow',
                status: {
                  state: 'offline',
                  last_changed: '14 July, 20:00'
                }
              }
            ],
            typingUsers: [ 4321 ]
          },
          {
            roomId: 2,
            roomName: 'Person 2',
            lastMessage: {
              content: 'Last message received',
              sender_id: 1234,
              username: 'John Doe',
              timestamp: '10:20',
              date: 123242424,
              seen: false,
              new: true
            },
            users: [
              {
                _id: 1234,
                username: 'John Doe',
                status: {
                  state: 'online',
                  last_changed: 'today, 14:30'
                }
              },
              {
                _id: 4321,
                username: 'John Snow',
                status: {
                  state: 'offline',
                  last_changed: '14 July, 20:00'
                }
              }
            ],
            typingUsers: [ 4321 ]
          },
          {
            roomId: 3,
            roomName: 'Person 3',
            lastMessage: {
              content: 'Last message received',
              sender_id: 1234,
              username: 'John Doe',
              timestamp: '10:20',
              date: 123242424,
              seen: false,
              new: true
            },
            users: [
              {
                _id: 1234,
                username: 'John Doe',
                status: {
                  state: 'online',
                  last_changed: 'today, 14:30'
                }
              },
              {
                _id: 4321,
                username: 'John Snow',
                status: {
                  state: 'offline',
                  last_changed: '14 July, 20:00'
                }
              }
            ],
            typingUsers: [ 4321 ]
          }
        ],
        messages: [
          
        ],
        currentUserId: 1234
      }
    },
    mounted(){
          postscribe('#mydiv2', '<script>    !function(){function e(){var e=t.createElement("script");e.type="text/javascript",e.async=!0,e.src="https://widget.customerly.io/widget/28f2fded";var r=t.getElementsByTagName("script")[0];r.parentNode.insertBefore(e,r)}var r=window,t=document,n=function(){n.c(arguments)};r.customerly_queue=[],n.c=function(e){r.customerly_queue.push(e)},r.customerly=n,r.attachEvent?r.attachEvent("onload",e):r.addEventListener("load",e,!1)}();customerly("start", {app_id: "28f2fded"});<' + '/script>');
    }
  }
</script>

<style>
h1, h2, h3 {
  color: black;
}

#PageContainer {
  display:flex;
  flex-direction:column; 
}

.stats-grid-container {
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  grid-template-rows: repeat(16, 1fr);
  gap: 1px 1px;
  height: 65vh;
  width: 100%;
}

.stats-stats { grid-area: 1 / 1 / 16 / 5; margin: 2px; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.05); }

.stats-status { grid-area: 1 / 5 / 5 / 9; margin: 2px; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.05); }

.stats-notification { grid-area: 5 / 5 / 16 / 9; margin: 2px; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.05); }

.stats-updates { grid-area: 1 / 9 / 16 / 12; margin: 2px; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.05); }

.st-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 1px 1px;
 grid-template-areas: "st-grid1 st-grid2" "st-grid3 st-grid4" "st-grid5 st-grid6" "st-grid7 st-grid8";
 height:80%;
 width: 90%;
 margin-top: 10%;
}

.st-grid1 { grid-area: st-grid1; margin: auto; }

.st-grid2 { grid-area: st-grid2; margin: auto; }

.st-grid3 { grid-area: st-grid3; margin: auto; text-align: left; }

.st-grid4 { grid-area: st-grid4; margin: auto; }

.st-grid5 { grid-area: st-grid5; margin: auto; }

.st-grid6 { grid-area: st-grid6; margin: auto; }

.st-grid7 { grid-area: st-grid7; margin: auto; }

.st-grid8 { grid-area: st-grid8; margin: auto; }


</style>

